/**
 * Generic UI-injection slots exposed by the disease-profile WorkHub manager (`Manager_DiseaseProfile`).
 * The host (disease-profile) owns these extension-point keys and renders the slots; other packages
 * register components into them via `ModuleFE_Utils.registerRenderer` — disease-profile never imports
 * the feature packages that fill them (mirrors the pathway slots).
 */
export const RendererKey_DiseaseProfileImportSave = 'disease-profile-import-save';
export const RendererKey_DiseaseProfileImportErrors = 'disease-profile-import-errors';
export const RendererKey_DiseaseProfileHtml = 'disease-profile-html';
export const RendererKey_DiseaseProfileReview = 'disease-profile-review';
//# sourceMappingURL=renderer-keys.js.map